import type { CurrentUserInfo } from '~/ducks/authentication/data/AuthenticationState';

type FleetInitialData = {
  currentUser?: Promise<Response>;
  currentUserJson?: CurrentUserInfo;
};

const getInitialData = (): FleetInitialData | undefined => {
  return (globalThis as unknown as { __fleetInitialData?: FleetInitialData }).__fleetInitialData;
};

export const clearInitialData = (): void => {
  delete globalThis.__fleetInitialData;
};

export const readInitialCurrentUser = async (): Promise<CurrentUserInfo | undefined> => {
  const initialData = getInitialData();
  if (!initialData) {
    return undefined;
  }

  if (initialData.currentUserJson) {
    return initialData.currentUserJson;
  }

  const initialPromise = initialData.currentUser;
  if (!initialPromise) {
    return undefined;
  }

  try {
    const response = await initialPromise;
    if (!response?.ok) {
      return undefined;
    }

    // Clone to avoid consuming the body if someone else awaits it.
    const user = (await response.clone().json()) as CurrentUserInfo;
    initialData.currentUserJson = user;
    return user;
  } catch {
    return undefined;
  }
};
